import { CoreInitiativesSonarObjectsName } from './name';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getInitiativeSonarObjects } from '@api';
import { updateSonarObjectReferences } from '../../sonar-objects/_idMap/actions';

export const coreInitiativesSonarObjectsGetAsyncSlice = createGetAsyncSlice({
	httpSagaOptions: {
		successDataActionCreators: [
			(response) =>
				updateSonarObjectReferences(
					response.results.map((result) => ({
						displayName: result.displayName,
						isActive: !result.isVanished,
						isDeleted: result.isVanished,
						parentDisplayName: result.parentDisplayName,
						parentSonarObjectId: result.parentSonarObjectId,
						relatedCounts: result.relatedCounts,
						sonarObjectId: result.sonarObjectId,
						sonarObjectType: result.sonarObjectType,
						statusId: result.sonarObjectStatusId,
						tags: [ ...result.tagIds ],
						versionNumber: result.versionNumber
					}))
				)
		]
	},
	name: CoreInitiativesSonarObjectsName,
	receive: true,
	request: true,
	requestHandler: getInitiativeSonarObjects,
	retainDataOnRequest: true
});
